<template>
    <div>
        <section class="full-navbar-section">
            <div class="container">
                <b-navbar toggleable="md" type="light" class="full-navbar">

                    <b-navbar-brand :to="{name: 'home'}">
                        <img src="~@/assets/images/main/sleep-outfitters-logo.png" alt="Tempur-Pedic" class="img-fluid">
                    </b-navbar-brand>

                    <!-- <b-navbar-toggle target="nav_collapse">
                        <img src="~@/assets/images/utilities/collapse-button-black.png" alt="Menu">
                    </b-navbar-toggle>

                    <b-collapse is-nav id="nav_collapse">
                        <b-navbar-nav>
                            <b-nav-item href="https://www.tempurpedic.com/shop-mattresses/" target="_blank">Shop</b-nav-item>
                            <b-nav-item href="https://www.tempurpedic.com/reviews" target="_blank">Reviews</b-nav-item>
                        </b-navbar-nav>
                    </b-collapse> -->

                </b-navbar>
            </div>
        </section>
    </div>
</template>

<script>
export default {
    name: 'navbar',
    data () {
        return {
        }
    },
    methods: {
    },
    computed: {
    }
}
</script>

<style lang="scss" scoped>
    @import '~@/assets/css/app.scss';

    .full-navbar-section {
        background-color: rgba($white, 0.8);
        border-bottom: 1px solid rgba($black, 0.15);
        padding-top: 10px;
        padding-bottom: 10px;
        position: relative;
        z-index: 2;

        @media (min-width: 992px) {
            margin-bottom: -84px;
        }

        .full-navbar {
            .navbar-brand {
                margin-top: -4px;
            }

            img {
                max-height: 40px;
            }
        }
    }

    .navbar-toggler {
        border-color: transparent !important;
        margin-top: 0px;
    }
</style>
